const obterNome = (nomes) => {
    var nome = "Nova Árvore";
    if (nomes.some((n) => n === nome)) {
        var c = 2;
        while (nomes.some((n) => n === "Nova Árvore (" + c + ")")) {
            c++;
        }
        nome = "Nova Árvore (" + c + ")";
    }
    return nome;
};

const fromStringToFile = (content) => {
    const file = new Blob([content], { type: "text/plain" });
    return file;
};

class ServicoArvores {
    constructor({ api }) {
        this.api = api;
    }

    obterArvores({ idContexto }) {
        return this.api
            .get(`/api/admin/arvore?contextoId=${idContexto}`)
            .then((response) => response.data);
    }

    obterArvore(id) {
        return this.api
            .get(`/api/admin/arvore/${id}`)
            .then((response) => response.data);
    }

    arvoreExiste(nome) {
        return this.obterArvorePorNome(nome)
            .then(() => true)
            .catch(() => false);
    }

    obterArvorePorNome(nome) {
        return this.api
            .get(`/api/admin/arvore/nome/${nome}`)
            .then((response) => response.data);
    }

    criarArvore({ idContexto }) {
        return this.api
            .get(`/api/admin/arvore?contextoId=${idContexto}`)
            .then((response) => response.data)
            .then((data) => {
                return data.map((arvore) => arvore.nome);
            })
            .then((nomes) => {
                var nome = obterNome(nomes);
                return {
                    nome,
                    habilitada: false,
                    texto: "",
                    contextoId: idContexto,
                };
            });
    }

    orderDown(id) {
        return this.api
            .patch(`/api/admin/arvore/${id}/orderdown`)
            .then((response) => {
                return response.data;
            });
    }

    orderUp(id) {
        return this.api
            .patch(`/api/admin/arvore/${id}/orderup`)
            .then((response) => response.data);
    }

    verificarCodigo(texto) {
        const fileName = "aquivo.yaml";
        const file = fromStringToFile(texto);
        const formData = new FormData();
        formData.append("arquivo", file, fileName);

        return this.api
            .post(`/api/admin/arvore/verificar`, formData)
            .then((response) => response.data);
    }

    salvarArvore(arvore) {
        if (arvore.id) {
            return this.api
                .put(`/api/admin/arvore/${arvore.id}`, arvore)
                .then((response) => response.data)
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response);
                    }
                    console.log(error);
                    throw error;
                });
        } else {
            return this.api
                .post("/api/admin/arvore", arvore)
                .then((response) => response.data)
                .catch((error) => {
                    if (error.response) {
                        console.log(error.response);
                    }
                    console.log(error);
                    throw error;
                });
        }
    }

    lancarArvore(arvore) {
        return this.api
            .put(`/api/admin/arvore/${arvore.id}/lancar`, arvore)
            .then((response) => response.data)
            .catch((error) => {
                if (error.response) {
                    console.log(error.response);
                }
                console.log(error);
                throw error;
            });
    }

    desabilitarArvore(arvore) {
        return this.api
            .patch(`/api/admin/arvore/${arvore.id}/desabilitar`)
            .then((response) => response.data)
            .catch((error) => {
                if (error.response) {
                    console.log(error.response);
                }
                console.log(error);
                throw error;
            });
    }

    apagarArvore(arvore) {
        return this.api
            .delete(`/api/admin/arvore/${arvore.id}`)
            .then((response) => response.data)
            .catch((error) => {
                if (error.response) {
                    console.log(error.response);
                }
                console.log(error);
                throw error;
            });
    }
}

export default ServicoArvores;
